import { Modal } from "@appkit4/react-components";
import { useEffect, useState } from "react";
import toast from "../../../components/DismissibleToast";
import { Button, Select } from "../../../components/ReadonlyAwareInputs";
import sqldatabaseService from "../../../services/sqldatabase/sqldatabase.service";
import "../home.scss";
import { getIdByName, getNamesFromList } from "../util/homeUtil";

const DeleteGroupModal = ({
  groupList,
  fetchGroups,
  resetForm,
  setResetForm,
}) => {
  const [selectedGroupNames, setSelectedGroupNames] = useState([]);
  const [selectedGroupIDs, setSelectedGroupIDs] = useState([]);
  const [buttonsDisabled, setButtonsDisabled] = useState(false);
  const [confirmationModalVisible, setConfirmationModalVisible] =
    useState(false);
  const [confirmButtonDisabled, setConfirmButtonDisabled] = useState(false);

  useEffect(() => {
    if (resetForm) {
      setSelectedGroupNames([]);
      setResetForm(false);
    }
  }, [resetForm]);

  useEffect(() => {
    const groupIDs = selectedGroupNames.map((groupName) =>
      getIdByName(groupName, groupList),
    );
    setSelectedGroupIDs(groupIDs);
  }, [selectedGroupNames]);

  const deleteGroups = async () => {
    setConfirmButtonDisabled(true);
    if (selectedGroupIDs.length > 0) {
      setButtonsDisabled(true);
      const promise = sqldatabaseService
        .postDeleteGroups(selectedGroupIDs)
        .then((response) => {
          if (response.status !== 200) {
            // Return an object that includes the error message instead of throwing an error
            return {
              error: true,
              message: `Error: Status ${response.status} - ${response.err}`,
            };
          }
          return response;
        });

      return toast
        .promise(promise, {
          loading: `Deleting ${selectedGroupIDs.length} groups...`,
          success: (response) => {
            // Check if there was an error
            if (response.error) {
              throw new Error(response.message);
            }
            setConfirmButtonDisabled(false);
            setConfirmationModalVisible(false);
            setSelectedGroupNames([]);
            setSelectedGroupIDs([]);
            fetchGroups();
            return `Deleted ${selectedGroupIDs.length} groups.`;
          },
          error: (response) => {
            // Show the error message in the toast
            setConfirmButtonDisabled(false);
            return `Failed to delete groups.`;
          },
        })
        .then(() => setButtonsDisabled(false));
    }
  };

  const cancelDeleteGroups = () => {
    setSelectedGroupNames([]);
    setConfirmationModalVisible(false);
    setConfirmButtonDisabled(false);
  };

  return (
    <div>
      <div className="flex-space-between">
        <Select
          placeholder={"Select Groups (Maximum 5)"}
          value={selectedGroupNames}
          multiple
          className="col"
          style={{ width: "35rem" }}
          searchable
          data={getNamesFromList(groupList)}
          onSelect={(groupNames) => {
            if (groupNames.length <= 5) {
              setSelectedGroupNames(groupNames);
            } else {
              setSelectedGroupNames(groupNames.slice(0, 5));
            }
          }}
          allowClear={true}
          onClear={() => {
            setSelectedGroupNames([]);
          }}
          dropdownRenderMode={"portal"}
        ></Select>
        <div style={{ flex: "1 10px 0" }}></div>
        <Button kind={"secondary"} onClick={() => cancelDeleteGroups()}>
          Clear Groups
        </Button>
        <Button
          className="col-2 m-1"
          disabled={selectedGroupNames.length === 0}
          onClick={() => {
            setConfirmationModalVisible(true);
          }}
        >
          Delete Groups
        </Button>
      </div>

      <Modal
        initialFocus={false}
        visible={confirmationModalVisible}
        title={"Admin Pannel"}
        ariaLabel={"Admin Pannel"}
        onCancel={() => cancelDeleteGroups()}
        maskCloseable={false}
        modalStyle={{ width: "70rem" }}
        footerStyle={{
          paddingTop: "8px",
          marginTop: "-8px",
          minHeight: "100px",
        }}
        header={""}
        icons={""}
      >
        <h1>
          You are about to permanently delete {selectedGroupNames.length} group
          {selectedGroupNames.length > 1 && "s"}. <br></br>This action cannot be
          undone and all associated data (including responses and
          subcollections) will be removed.
        </h1>
        <br />
        <div className="custom-scrollable">
          <ul>
            {selectedGroupNames.map((group) => {
              return <li>{group}</li>;
            })}
          </ul>
        </div>
        <br />
        <div className="flex-end">
          <Button
            onClick={() => cancelDeleteGroups()}
            disabled={confirmButtonDisabled}
            loading={confirmButtonDisabled}
          >
            Cancel
          </Button>
          <Button
            onClick={() => deleteGroups()}
            disabled={confirmButtonDisabled}
            loading={confirmButtonDisabled}
          >
            Confirm
          </Button>
        </div>
      </Modal>
    </div>
  );
};

export default DeleteGroupModal;
